
function timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y;
    Y = date.getFullYear() + '-';
    let M;
    M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let D;
    D = (date.getDate()< 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    let h;
    h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m;
    m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let s;
    s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y+M+D+h+m+s;
}

export {timestampToTime}